var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Pakistan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e3e4e5",
    d: "M4,24c0,6.873,3.469,12.933,8.75,16.534V7.466C7.469,11.067,4,17.127,4,24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b5e20",
    d: "M44,24c0-11.046-8.954-20-20-20c-4.173,0-8.044,1.281-11.25,3.466v33.067 C15.956,42.719,19.827,44,24,44C35.046,44,44,35.046,44,24z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M38,24c0,4.969-4.031,9-9,9s-9-4.031-9-9s4.031-9,9-9S38,19.031,38,24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1b5e20",
    d: "M37.852,15.852c-3.117-3.508-8.488-3.824-12-0.707c-3.508,3.121-3.824,8.492-0.703,12 c3.117,3.512,8.492,3.824,12,0.707S40.973,19.359,37.852,15.852z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M32,17l3.531,4.852L29.82,20l5.707-1.855L32.004,23L32,17z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Pakistan);
export default __webpack_public_path__ + "static/media/icons8-pakistan.14fe419955311f153496b102fcb1a326.svg";
export { ForwardRef as ReactComponent };